// ONE host for the RecordCard quick view: scrim + shell drawer chrome + wide toggle + focus. Every page renders
// <RecordCardDrawerHost query={q} onClose={() => setQ(null)} {...RecordCard props} /> instead of its own drawer markup.
// Esc + focus trap/restore come from DrawerFrame (one implementation); scrim click closes there; wide resets because the inner part unmounts with the query.
import React, { useState } from 'react';
import DrawerFrame from '../shell/drawer/DrawerFrame';
import useActionLabel from '../i18n/useActionLabel';
import RecordCard from './RecordCard';

function Open({ onClose, testId, ...card }) {
  const [wide, setWide] = useState(false);
  const al = useActionLabel();
  return (
    <DrawerFrame size={wide ? 'expanded' : 'standard'} onClose={onClose} label={al('quickView')} testId={testId}>
      <RecordCard {...card} onClose={onClose} onExpand={() => setWide(w => !w)} wide={wide} />
    </DrawerFrame>
  );
}

export default function RecordCardDrawerHost({ query, ...rest }) {
  return query ? <Open query={query} {...rest} /> : null;
}
